module.exports = __webpack_public_path__ + "static/media/pamain-bold.6ee779ad.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-bold.eot
// module id = ./src/assets/fonts/pamain-bold.eot
// module chunks = 0